import * as React from "react";
import { useParams, Navigate } from "react-router-dom";
import { useAppDispatch } from "../../../../store/hooks";

type RouteParams = "id";

interface Props {}
export const SignUpWithId: React.FC<Props> = () => {
  const dispatch = useAppDispatch();
  const { id } = useParams<RouteParams>();
  const [isReady, setIsReady] = React.useState(false);

  React.useEffect(() => {
    if (id) {
      // TODO fix
      // dispatch(setReferralId(id));
    }
    setIsReady(true);
  }, []);

  if (!isReady) {
    return null;
  }

  return <Navigate to={`/signup`} />;
};
